import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/*
 * @Author: wangshengqiang
 * @Date: 2021-05-07 14:36:38
 * @LastEditTime: 2021-10-22 17:58:40
 * @LastEditors: wangshengqiang
 * @Description: 问卷告知列表页面
 */
import React, { useEffect, useState } from 'react';
import { Checkbox, Button, Toast } from 'zarm';
import { getState, dispatch } from '@/store';
import './index.less';
import { getPackageList } from '@/utils/utils';
import { PLAN_ID } from '@/constants';
import { queryNoticeQuestion } from '@/services/JDservice';
import { rulesProduct } from '@/utils/planRelationMethods/rulesProduct.js';
import { useQueryOrderDetail, getPremium } from './methods'; // const testHolder =
//   '抱歉，您不符合投保要求！非常抱歉，因为您曾经患有肺癌，您未能通过本次投保审核，请选择其他保险产品';

const HealthNotificationList = () => {
  const [data] = useQueryOrderDetail() || [];
  const {
    mixList = [],
    resultObj = {},
    hasExemption = false
  } = data || {};
  const [list, setList] = useState(mixList);
  const [hasNotice, setHasNotice] = useState();

  const finalParams = _list => {
    // 有投保人豁免的话  投保人必须填写过问卷  并且是标体才能继续
    const holder = _list.find(item => item.personType === 'holder');

    if (holder && holder.selected !== true) {
      return;
    } // 从列表中拿到被保人


    const insuredList = _list.flatMap((item, index) => {
      if (item.personType === 'insured') {
        if (item.selected === true) {
          return item;
        }

        item.selected = false;
        return item;
      }

      return [];
    }); // 把勾选的被保人存下来 下一步接口时候根据这个过滤


    const checkedList = insuredList.flatMap(item => {
      if (item.selected === true) {
        var _item$person;

        return (_item$person = item.person) === null || _item$person === void 0 ? void 0 : _item$person.certNo;
      }

      return [];
    });
    const noticeListState = getState('noticeList');
    dispatch('noticeList', _objectSpread(_objectSpread({}, noticeListState), {}, {
      checkedList
    })); // 校验

    const hasInsured = insuredList.some(ins => ins.selected);

    if (!hasInsured) {
      Toast.show('请至少选择一个被保人');
      return;
    }

    const packageList = getPackageList() || [];

    if (!getState('hasInsurancePlanModule')) {
      const insuredLength = insuredList.filter(item => item.selected).length;
      insuredList.forEach(item => {
        item.packageList = rulesProduct(packageList, item.person, insuredLength);
      });
    }

    if (resultObj) {
      resultObj.insuredList = insuredList;
    }

    getPremium(resultObj);
  }; // 遍历配置查找对应告知页面


  const getInsurerNoticePage = (target = 'healthInfoModule') => {
    var _config$pageList;

    const config = getState('configJson') || {};
    return (_config$pageList = config.pageList) === null || _config$pageList === void 0 ? void 0 : _config$pageList.find(page => {
      var _page$moduleList;

      return undefined !== ((_page$moduleList = page.moduleList) === null || _page$moduleList === void 0 ? void 0 : _page$moduleList.find(module => {
        return module.component === target;
      }));
    });
  };

  const toNoticePage = (certNo, personType) => {
    const map = {
      holder: 'policyHolderInfoModule',
      insured: 'healthInfoModule'
    };
    const noticePage = getInsurerNoticePage(map[personType]) || {};
    const {
      pageOrder
    } = noticePage;
    window.location.hash = `#page=${pageOrder}&certNo=${certNo}`;
  }; // 初始化


  useEffect(() => {
    if (list && list.length !== 0) {
      finalParams(list);
    }
  }, [list]);
  useEffect(() => {
    if (!hasNotice) {
      const planId = getState(PLAN_ID);
      const _hasNotice = [];
      Promise.all(['holder', 'insured', 'agent'].map(item => {
        return queryNoticeQuestion({
          noticeType: 'healthNotice',
          noticeObjectType: item,
          planId
        }).then(res => {
          if ((res === null || res === void 0 ? void 0 : res.success) === true && res !== null && res !== void 0 && res.result) {
            _hasNotice.push(item);
          }
        });
      })).then(() => {
        setHasNotice(_hasNotice);
        const noticeListState = getState('noticeList');
        dispatch('noticeList', _objectSpread(_objectSpread({}, noticeListState), {}, {
          hasNotice: _hasNotice
        }));
      });
    }

    return () => {
      dispatch('noticeList', undefined);
    };
  }, []);
  useEffect(() => {
    // 检查所有人是否有问卷  并改变状态
    const checkNotice = () => {
      if (!mixList || !hasNotice) return;

      const _list = mixList.filter((item, index) => {
        const show = hasNotice.indexOf(item.personType) !== -1; // 过滤没有告知的

        if (show) {
          // 根据问卷状态禁用
          item.isRefuseStatus = item.allowInsure === false;
          item.selected = item.allowInsure !== false; // 如果是投保人 则不可修改

          if (item.personType === 'holder') {
            item.unchangeable = true; // 过滤掉没投豁免险的投保人

            if (!hasExemption) return false;
          }
        }

        return show;
      });

      setList(_list); // 每次进入页面重新储存勾选列表

      const checkedList = [];

      _list.forEach(item => {
        if (item.personType === 'insured' && item.selected === true && item.person) {
          checkedList.push(item.person.certNo);
        }
      });

      const noticeListState = getState('noticeList');
      dispatch('noticeList', _objectSpread(_objectSpread({}, noticeListState), {}, {
        checkedList
      }));
    };

    checkNotice();
  }, [mixList, hasNotice]);

  const checkChange = (value, certiNo, personType, index) => {
    list[index].selected = !!value;
    setList([...list]);
    finalParams(list);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "HealthNotificationList"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, /*#__PURE__*/React.createElement("p", null, "\u6295\u4FDD\u4EBA\u5E94\u5728\u5BF9\u6240\u6709\u88AB\u4FDD\u9669\u4EBA\u5065\u5EB7/\u804C\u4E1A\u72B6\u51B5\u5145\u5206\u4E86\u89E3\u7684\u57FA\u7840\u4E0A\u5C65\u884C\u5982\u5B9E\u544A\u77E5\u4E49\u52A1\u3002\u6295\u4FDD\u4EBA\u627F\u8BFA\u5B8C\u5168\u77E5\u6653\u6240\u6709\u88AB\u4FDD\u9669\u4EBA\u5065\u5EB7/\u804C\u4E1A\u72B6\u6001\u3002"), /*#__PURE__*/React.createElement("p", null, "\u82E5\u88AB\u4FDD\u9669\u4EBA\u5065\u5EB7/\u804C\u4E1A\u72B6\u51B5\u4E0E\u4E0B\u8FF0\u544A\u77E5\u5185\u5BB9\u4E0D\u7B26\uFF1A"), /*#__PURE__*/React.createElement("p", null, "\uFF081\uFF09\u672C\u516C\u53F8\u6709\u6743\u4E0D\u540C\u610F\u627F\u4FDD\u3002"), /*#__PURE__*/React.createElement("p", null, "\uFF082\uFF09\u82E5\u53D1\u751F\u4FDD\u9669\u4E8B\u6545\uFF0C\u672C\u516C\u53F8\u4E0D\u627F\u62C5\u8D54\u507F\u6216\u7ED9\u4ED8\u4FDD\u9669\u91D1\u7684\u8D23\u4EFB\uFF0C\u5E76\u6709\u6743\u4E0D\u9000\u8FD8\u4FDD\u8D39\u3002")), /*#__PURE__*/React.createElement("div", {
    className: "list"
  }, list.map((item, index) => {
    const {
      person = {},
      personType,
      noticeQuestion,
      notAllowInsureReason,
      allowInsure,
      isRefuseStatus,
      unchangeable,
      // 投保人 && 有投保人告知
      selected
    } = item;
    const {
      name,
      certNo
    } = person;
    const noticeResult = allowInsure && '符合要求' || allowInsure === null ? '待完成' : '不符合要求';
    const buttonText = allowInsure !== null ? '重新填写' : '点击进行告知填写';
    return /*#__PURE__*/React.createElement("div", {
      className: "item",
      key: certNo
    }, /*#__PURE__*/React.createElement("div", {
      className: "item-left"
    }, !unchangeable && /*#__PURE__*/React.createElement(Checkbox, {
      checked: !isRefuseStatus && selected,
      disabled: isRefuseStatus,
      onChange: e => {
        checkChange(e.target.checked, certNo, personType, index);
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "item-right"
    }, /*#__PURE__*/React.createElement("div", {
      className: "top"
    }, /*#__PURE__*/React.createElement("div", {
      className: "left"
    }, /*#__PURE__*/React.createElement("span", {
      className: "left"
    }, name), /*#__PURE__*/React.createElement("span", {
      className: "right"
    }, personType === 'holder' ? '投保人' : '被保人')), /*#__PURE__*/React.createElement("div", {
      className: `right ${allowInsure === false ? 'red' : ''}`
    }, noticeResult)), /*#__PURE__*/React.createElement("div", {
      className: "middle"
    }, notAllowInsureReason), /*#__PURE__*/React.createElement("div", {
      className: "bottom"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
      theme: "primary",
      size: "xs",
      onClick: () => {
        dispatch('otherParams.currentInsured', index);
        toNoticePage(certNo, personType);
      }
    }, buttonText)))));
  })));
};

export default HealthNotificationList;